import React, { useEffect, useState } from "react";
import PdfIcon from "../../Assets/svgs/PdfIcon";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "../../Common/Loader";
import { getFormSubmissionDetail } from "../../Redux/Slice/Form/GetFormSubmissionDetailSlice";
import { useLocation } from "react-router-dom";
import { dateFormat } from "../../Common/DateAndTimeFormat";
import TxtIcon from "../../Assets/svgs/TxtIcon";
import MarkdownIcon from "../../Assets/svgs/MarkdownIcon";
import WordIcon from "../../Assets/svgs/WordIcon";
import { downloadFileAsBlob } from "../../Common/utils";
import { ErrorModel } from "../../Model/ErrorModel";
import { SuccessModel } from "../../Model/SuccessModel";

const AssistantFormSubmissionDetail = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  let splittedPaths = location.pathname.split("/");
  let submissionId = splittedPaths[splittedPaths?.length - 1];
  const { submissionDetailData, loading } = useSelector(
    (state) => state?.submissionDetail
  );
  const [isLoading, setIsLoading] = useState(false);
  const [successModal, setSuccessModal] = useState({
    visible: false,
    message: "",
  });
  const [errorModal, setErrorModal] = useState({ visible: false, message: "" });

  const formFields =
    submissionDetailData?.data?.form?.fields &&
    Array.isArray(submissionDetailData?.data?.form?.fields)
      ? submissionDetailData?.data?.form?.fields
      : [];

  const formFieldsData = submissionDetailData?.data?.responses
    ? submissionDetailData?.data?.responses
    : {};

  const showSuccessMessage = (message, callback) => {
    setSuccessModal({
      visible: true,
      message: message ?? "Something went wrong, please try again later!",
    });

    setTimeout(() => {
      setSuccessModal({ visible: false, message: "" });
      if (typeof callback === "function") {
        callback();
      }
    }, 3000);
  };

  const showErrorMessage = (message, callback) => {
    setErrorModal({
      visible: true,
      message: message ?? "Something went wrong, please try again later!",
    });

    setTimeout(() => {
      setErrorModal({ visible: false, message: "" });
      if (typeof callback === "function") {
        callback();
      }
    }, 2000);
  };

  const checkAndAddProtocolUrl = (url)=>{
    const hasProtocol = url.startsWith("http://") || url.startsWith("https://");
    const finalUrl = hasProtocol ? url : `https://${url}`;
    return finalUrl;
  }

  const onDownloadFile = async (fileUrl) => {
    setIsLoading(true);
    try {
      await downloadFileAsBlob(fileUrl);
      setIsLoading(false);
      showSuccessMessage("File downloaded successfully!");
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    dispatch(getFormSubmissionDetail(submissionId));
  }, []);

  return (
    <div className="page__body">
      {loading || isLoading ? <Loader /> : null}
      {errorModal.visible && <ErrorModel message={errorModal.message} />}
      {successModal.visible && <SuccessModel message={successModal.message} />}
      <div className="details">
        <div className="form">
          <section className="form__section">
            <div className="formRow formRow__2">
              {formFields?.map((field) => {
                const splittedFieldData =
                  field?.type == "upload"
                    ? (formFieldsData[field?.label] ?? "")?.split("/")
                    : [];
                const fileName = splittedFieldData?.length
                  ? splittedFieldData[splittedFieldData?.length - 1]
                  : "";
                const fileTypeList = fileName?.split(".");
                const fileType = fileTypeList?.length
                  ? fileTypeList[fileTypeList?.length - 1]
                  : "";
                return (
                  <div className="formCol">
                    <label className="form__label">{field?.name}</label>
                    {field?.type == "date" && formFieldsData[field?.label] ? (
                      <h1>
                        {formFieldsData[field?.label]
                          ? dateFormat(formFieldsData[field?.label])
                          : "N/A"}
                      </h1>
                    ) : field?.type == "upload" &&
                      formFieldsData[field?.label] ? (
                      <a
                        onClick={() =>
                          onDownloadFile(formFieldsData[field?.label])
                        }
                      >
                        <p>
                          {fileType == "txt" ? (
                            <TxtIcon width={21} height={21} />
                          ) : fileType == "md" ? (
                            <MarkdownIcon width={21} height={21} />
                          ) : fileType == "doc" || fileType == "doc" ? (
                            <WordIcon width={21} height={21} />
                          ) : (
                            <PdfIcon width={21} height={21} />
                          )}{" "}
                          {fileName}
                        </p>
                      </a>
                    ) : field?.type == "url" &&
                      formFieldsData[field?.label] ? (
                      <a
                        href={checkAndAddProtocolUrl(formFieldsData[field?.label])}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <h1>{formFieldsData[field?.label] ?? "N/A"}</h1>
                      </a>
                    ) : (
                      <h1>{formFieldsData[field?.label] ?? "N/A"}</h1>
                    )}
                  </div>
                );
              })}
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default AssistantFormSubmissionDetail;
